/**
 * Platform API base URL. Same Cognito pool; api.georgii.tech for platform routes.
 */
export const API_BASE =
  (import.meta as any).env?.VITE_PLATFORM_API_URL ||
  'https://api.georgii.tech';
